/**
 * Blog URL helpers. DB titles often end with "?"; omit that from path segments
 * so sitemaps/Google do not index "...%3F" URLs.
 */

export function blogPathSlug(title) {
  let t = String(title || '').trim()
  while (t.endsWith('?')) {
    t = t.slice(0, -1).trimEnd()
  }
  return t.replace(/ /g, '-')
}

export function blogPathToLookupTitle(pathSegment) {
  let t = String(pathSegment || '')
  try {
    t = decodeURIComponent(t)
  } catch (e) {
    // keep raw
  }
  while (t.endsWith('?') || t.toUpperCase().endsWith('%3F')) {
    if (t.endsWith('?')) {
      t = t.slice(0, -1)
    } else {
      t = t.slice(0, -3)
    }
    t = t.trimEnd()
  }
  return t.replace(/-/g, ' ')
}
